import React, { FC } from 'react';

import { Position } from '@zazume/zzm-base';

import { IdentifierDTO, isZazumeUser, User } from '../../../../models';
import { DropdownItemProps } from '../../../dropdown/atoms/Item';
import { BaseOrganizationOptions } from './components/BaseOrganizationOptions';
import { ZazumeOrganizationOptions } from './components/ZazumeOrganizationOptions';

export interface OrganizationOptionsProps extends DropdownItemProps {
  onSelect: (organizationId: IdentifierDTO) => void;
  header: any;
  user: User;
  position?: Position;
  topValue?: number;
}

export const OrganizationOptions: FC<OrganizationOptionsProps> = ({ onSelect, header, user, position, topValue }) => {
  if (isZazumeUser(user)) {
    return <ZazumeOrganizationOptions onSelect={onSelect} header={header} position={position} topValue={topValue} />;
  }

  if (!user.owner?.ownerAccountId) {
    return null;
  }

  return (
    <BaseOrganizationOptions
      onSelect={onSelect}
      header={header}
      ownerAccountId={user.owner.ownerAccountId}
      position={position}
      topValue={topValue}
    />
  );
};
